import {
  FINTRAC_STR_ACCOUNT_TYPE_CODE_OPTIONS,
  FINTRAC_STR_CURRENCY_CODES_OPTIONS,
  FINTRAC_STR_VIRTUAL_CURRENCY_TYPE_CODE_OPTIONS,
  FINTRAC_STR_HOLDER_TYPE_CODE_OPTIONS,
  FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE,
  FINTRAC_STR_ACCOUNT_TYPE_CODE,
  FINTRAC_STR_OUT_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE,
  FINTRAC_STR_VIRTUAL_CURRENCY_TYPE_CODE,
  FINTRAC_STR_DATE_FORMAT,
  FINTRAC_STR_DEFINITION_TYPE_CODE_MAP,
} from 'app/modules/fintracStr/formConstants';
import {
  getDependentPaths,
  getUniqueDefinitionOptions,
} from 'app/modules/fintracStr/formUtils';
import {
  FintracFormFields,
  FintracFormValue,
} from 'app/modules/fintracStr/models';
import { isFieldBlank } from 'app/modules/fintracStr/renderConditions';
import {
  U21FormFieldTypes,
  U21SelectOptionProps,
} from 'app/shared/u21-ui/components';
import { formatDate } from 'app/shared/utils/date';
import { parseFintracDate } from 'app/modules/fintracStr/utils';
import { isUndefined } from 'lodash';

const isPhysicalFundAssetType = (value: FintracFormValue) =>
  value ===
    FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE.JEWELLERY.value ||
  value ===
    FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE.PRECIOUS_METALS
      .value ||
  value ===
    FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE.PRECIOUS_STONES.value;

export const FINTRAC_STR_STARTING_ACTION_ACCOUNT_INFORMATION_FIELDS: FintracFormFields =
  [
    [
      {
        type: U21FormFieldTypes.TEXT,
        name: 'financialInstitutionNumber',
        label: 'Financial institution number',
        mustExistInPayload: false,
        mustHaveValueIfExist: false,
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`
                  : '',
              conditions: (value) => isPhysicalFundAssetType(value),
            },
          ],
        },
      },
      {
        type: U21FormFieldTypes.TEXT,
        name: 'branchNumber',
        label: 'Branch number',
        mustExistInPayload: false,
        mustHaveValueIfExist: false,
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`
                  : '',
              conditions: (value) => isPhysicalFundAssetType(value),
            },
          ],
        },
      },
    ],
    {
      type: U21FormFieldTypes.TEXT,
      name: 'number',
      label: 'Account number',
      mustExistInPayload: false,
      mustHaveValueIfExist: false,
      dependentPaths: (sectionIndex, fieldSectionIndex) =>
        getDependentPaths(
          undefined,
          fieldSectionIndex && fieldSectionIndex.length === 1
            ? [
                `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`,
              ]
            : undefined,
          sectionIndex,
          fieldSectionIndex,
        ),
      hideIfTrue: {
        and: [
          {
            path: (sectionIndex, fieldSectionIndex) =>
              fieldSectionIndex && fieldSectionIndex.length === 1
                ? `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`
                : '',
            conditions: (value) => isPhysicalFundAssetType(value),
          },
        ],
      },
    },
    [
      {
        type: U21FormFieldTypes.SELECT,
        name: 'typeCode',
        label: 'Account type',
        fieldProps: {
          options: FINTRAC_STR_ACCOUNT_TYPE_CODE_OPTIONS,
        },
        mustExistInPayload: false,
        mustHaveValueIfExist: true,
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`
                  : '',
              conditions: (value) =>
                isPhysicalFundAssetType(value) ||
                value ===
                  FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE
                    .VIRTUAL_CURRENCY.value,
            },
          ],
        },
      },
      {
        type: U21FormFieldTypes.TEXT,
        name: 'typeOther',
        label: 'Other account type description',
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.account.typeCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.account.typeCode`
                  : '',
              conditions: (value) =>
                value !== FINTRAC_STR_ACCOUNT_TYPE_CODE.OTHER.value,
            },
          ],
        },
        mustExistInPayload: false,
        mustHaveValueIfExist: false,
      },
    ],
    {
      type: U21FormFieldTypes.SELECT,
      name: 'currencyCode',
      label: 'Account currency code',
      fieldProps: {
        options: FINTRAC_STR_CURRENCY_CODES_OPTIONS,
      },
      mustExistInPayload: false,
      mustHaveValueIfExist: true,
      dependentPaths: (sectionIndex, fieldSectionIndex) =>
        getDependentPaths(
          undefined,
          fieldSectionIndex && fieldSectionIndex.length === 1
            ? [
                `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.currencyCode`,
                `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`,
              ]
            : undefined,
          sectionIndex,
          fieldSectionIndex,
        ),
      hideIfTrue: {
        or: [
          {
            path: (sectionIndex, fieldSectionIndex) =>
              fieldSectionIndex && fieldSectionIndex.length === 1
                ? `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.currencyCode`
                : '',
            conditions: (value) => isFieldBlank(value),
          },
          {
            path: (sectionIndex, fieldSectionIndex) =>
              fieldSectionIndex && fieldSectionIndex.length === 1
                ? `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`
                : '',
            conditions: (value) =>
              isPhysicalFundAssetType(value) ||
              value ===
                FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE
                  .VIRTUAL_CURRENCY.value,
          },
        ],
      },
    },
    [
      {
        type: U21FormFieldTypes.SELECT,
        name: 'virtualCurrencyTypeCode',
        label: 'Account virtual currency type',
        fieldProps: {
          options: FINTRAC_STR_VIRTUAL_CURRENCY_TYPE_CODE_OPTIONS,
        },
        mustExistInPayload: false,
        mustHaveValueIfExist: true,
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.virtualCurrencyTypeCode`,
                  `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          or: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.virtualCurrencyTypeCode`
                  : '',
              conditions: (value) => isFieldBlank(value),
            },
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`
                  : '',
              conditions: (value) =>
                value ===
                  FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE
                    .BANK_DRAFT.value || // Bank draft
                value ===
                  FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE.CASH
                    .value || // Cash
                value ===
                  FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE.CHEQUE
                    .value || // Cheque
                value ===
                  FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE
                    .DOMESTIC_FUNDS_TRANSFER.value || // Domestic funds transfer
                value ===
                  FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE
                    .EMAIL_MONEY_TRANSFER.value || // Email money transfer
                value ===
                  FINTRAC_STR_OUT_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE
                    .FUNDS_WITHDRAWAL.value || // Funds withdrawal
                value ===
                  FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE
                    .INTERNATIONAL_FUNDS_TRANSFER.value || // International funds transfer
                value ===
                  FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE.JEWELLERY
                    .value || // Jewellery
                value ===
                  FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE
                    .MOBILE_MONEY_TRANSFER.value || // Mobile money transfer
                value ===
                  FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE
                    .MONEY_ORDER.value || // Money order
                value ===
                  FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE
                    .PRECIOUS_METALS.value || // Precious metals
                value ===
                  FINTRAC_STR_IN_FUND_ASSET_VIRTUAL_CURRENCY_TYPE_CODE
                    .PRECIOUS_STONES.value, // Precious stones
            },
          ],
        },
      },
      {
        type: U21FormFieldTypes.TEXT,
        name: 'virtualCurrencyTypeOther',
        label: 'Other virtual currency type description',
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.account.virtualCurrencyTypeCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.account.virtualCurrencyTypeCode`
                  : '',
              conditions: (value) =>
                value !== FINTRAC_STR_VIRTUAL_CURRENCY_TYPE_CODE.OTHER.value,
            },
          ],
        },
        mustExistInPayload: false,
        mustHaveValueIfExist: false,
      },
    ],
    [
      {
        type: U21FormFieldTypes.DATE_PICKER,
        name: 'dateOpened',
        label: 'Date account opened',
        mustExistInPayload: false,
        mustHaveValueIfExist: true,
        fieldProps: {
          maxDate: new Date(),
        },
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`
                  : '',
              conditions: (value) => isPhysicalFundAssetType(value),
            },
          ],
        },
        payloadToFormValueConversion: (parentPath, flattenedPayloadValue) => {
          const dateValue = flattenedPayloadValue[`${parentPath}.dateOpened`];
          const parsed = parseFintracDate(
            typeof dateValue === 'string' ? dateValue : undefined,
          );
          return { dateOpened: parsed };
        },
        formToPayloadValueConversion: (values) => {
          if (values instanceof Date) {
            return { dateOpened: formatDate(values, FINTRAC_STR_DATE_FORMAT) };
          }
          return {};
        },
      },
      {
        type: U21FormFieldTypes.DATE_PICKER,
        name: 'dateClosed',
        label: 'Date account closed',
        mustExistInPayload: false,
        mustHaveValueIfExist: true,
        fieldProps: {
          maxDate: new Date(),
        },
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.fundAssetVirtualCurrencyTypeCode`
                  : '',
              conditions: (value) => isPhysicalFundAssetType(value),
            },
          ],
        },
        payloadToFormValueConversion: (parentPath, flattenedPayloadValue) => {
          const dateValue = flattenedPayloadValue[`${parentPath}.dateClosed`];
          const parsed = parseFintracDate(
            typeof dateValue === 'string' ? dateValue : undefined,
          );
          return { dateClosed: parsed };
        },
        formToPayloadValueConversion: (values) => {
          if (values instanceof Date) {
            return { dateClosed: formatDate(values, FINTRAC_STR_DATE_FORMAT) };
          }
          return {};
        },
      },
    ],
    {
      type: 'section',
      repeatable: true,
      label: 'Account Holders Information',
      name: 'holders',
      mustExistInPayload: true,
      mustHaveValueIfExist: false,
      defaultNumOfEntries: 0,
      fields: [
        {
          type: U21FormFieldTypes.SELECT,
          name: 'typeCode',
          label: 'Account type',
          fieldProps: (_, mutators, sectionIndex, fieldSectionIndex) =>
            fieldSectionIndex && fieldSectionIndex.length === 2
              ? {
                  options: FINTRAC_STR_HOLDER_TYPE_CODE_OPTIONS,
                  onChange: () => {
                    mutators.setFieldValueUntyped(
                      `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.account.holders[${fieldSectionIndex[1]}].refId`,
                      '',
                    );
                  },
                }
              : { options: FINTRAC_STR_HOLDER_TYPE_CODE_OPTIONS },
          mustExistInPayload: true,
          mustHaveValueIfExist: true,
        },
        {
          type: U21FormFieldTypes.SELECT,
          name: 'refId',
          label: 'Subject name',
          mustExistInPayload: true,
          mustHaveValueIfExist: true,
          dependentPaths: (sectionIndex, fieldSectionIndex) =>
            getDependentPaths(
              undefined,
              fieldSectionIndex && fieldSectionIndex.length === 2
                ? [
                    `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.account.holders[${fieldSectionIndex[1]}].typeCode`,
                    `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.account.holders`,
                    `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.account.holders[${fieldSectionIndex[1]}]`,
                    'definitions', // Need to listen to definitions since getUniqueDefinitionOptions relies on definitions
                  ]
                : ['definitions'],
              sectionIndex,
              fieldSectionIndex,
            ),
          hideIfTrue: {
            and: [
              {
                path: (sectionIndex, fieldSectionIndex) =>
                  fieldSectionIndex && fieldSectionIndex.length === 2
                    ? `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.account.holders[${fieldSectionIndex[1]}].typeCode`
                    : '',
                conditions: (value) => isFieldBlank(value),
              },
            ],
          },
          fieldProps: (
            flattenedValues,
            _,
            sectionIndex,
            fieldSectionIndex,
          ) => ({
            noOptionsText: ((): string => {
              if (
                !isUndefined(sectionIndex) &&
                fieldSectionIndex &&
                fieldSectionIndex.length === 2
              ) {
                const label =
                  FINTRAC_STR_DEFINITION_TYPE_CODE_MAP[
                    flattenedValues[
                      `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.account.holders[${fieldSectionIndex[1]}].typeCode`
                    ]
                  ];

                if (label) {
                  return `No options available. Please create a new "${label}" definition in the definitions tab.`;
                }
              }

              return `No options available. Please create a new definition in the definitions tab.`;
            })(),
            options: ((): U21SelectOptionProps<string>[] =>
              !isUndefined(sectionIndex) &&
              fieldSectionIndex &&
              fieldSectionIndex.length === 2
                ? getUniqueDefinitionOptions(
                    flattenedValues,
                    `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.account.holders`,
                    `transactions[${sectionIndex}].startingActions[${fieldSectionIndex[0]}].details.account.holders[${fieldSectionIndex[1]}]`,
                  )
                : [])(),
          }),
        },
      ],
    },
  ];
